export const STORED_OFFERS_SKIPPED_SESSION = 'offersSkipped';
export const STORED_HISTORY_FLOOR = 'eklase:historyFloor';
